import { Injectable, OnDestroy } from '@angular/core';
import { StatePersistenceService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { MyShopFacade } from '../facade/my-shop.facade';

export interface SyncedMyShopState {
  name?: string;
}

@Injectable({ providedIn: 'root' })
export class MyShopPersistenceService implements OnDestroy {
  protected subscription = new Subscription();

  constructor(
    private statePersistenceService: StatePersistenceService,
    private myShopFacade: MyShopFacade,
  ) {}

  sync(): void {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: 'shop',
        state$: this.getMyShopState(),
        onRead: (state) => this.onRead(state),
      }),
    );
  }

  onRead(state: SyncedMyShopState): void {
    if (state?.name) {
      this.myShopFacade.setMyShopName(state.name);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  protected getMyShopState(): Observable<SyncedMyShopState> {
    return this.myShopFacade.getMyShopName().pipe(map((name) => ({ name })));
  }
}
